import UI2Layout from "@/layouts/UI2Layout.vue";
import UI2LayoutEmpty from "@/layouts/UI2LayoutEmpty.vue"

const routes = [
  {
    path: "/",
    component: UI2Layout,
    redirect: "/index", // 设置默认重定向
    children: [
      {
        path: "index", // 注意这里移除了前导斜线
        name: "index",
        component: () => import("@/ui2/Index.vue"), // 也可以使用懒加载
      },
      {
        path: "pool", // 注意这里移除了前导斜线
        name: "pool",
        component: () => import("@/ui2/Pool.vue"), // 也可以使用懒加载
      },
      {
        path: "coop", // 注意这里移除了前导斜线
        name: "coop",
        component: () => import("@/ui2/Coop.vue"), // 也可以使用懒加载
      },
      {
        path: "user", // 注意这里移除了前导斜线
        name: "user",
        component: () => import("@/ui2/User.vue"), // 也可以使用懒加载
      },
    ],
  },
  {
    path: "/page/",
    component: UI2LayoutEmpty, // 需要指定布局组件
    children:[
      {
        path: "withdraw", // 注意这里移除了前导斜线
        name: "withdraw",
        component: () => import("@/ui2/page/Withdraw.vue"), // 也可以使用懒加载
      },
      {
        path: "staking", // 注意这里移除了前导斜线
        name: "staking",
        component: () => import("@/ui2/page/Staking.vue"), // 也可以使用懒加载
      }
    ]
  },  
  {
    path: "/:pathMatch(.*)*", // 匹配所有未知路径
    redirect: "/index", // 重定向到首页
  }
];

export default routes;